// Centralized error and UI messages for the registration form

export const ERROR_MESSAGES = {
  firstName: 'First name is required',
  lastName: 'Last name is required',
  dateOfBirth: 'Date of birth is required',
  raceDistance: 'Please select a race distance',
  travelRequired: 'Please specify the travel requirements for your participation',
  notifyFutureEvents: 'Notifications: Choose Yes or No',
  sendRunningOffers: 'Other Information: Choose Yes or No',
  termsAccepted: 'You must accept the terms and conditions',
};
